export const printWarningWithTrace = message =>
// eslint-disable-next-line no-console -- appropriate here
console.trace(`☢️ WARNING:
${message}`);
//# sourceMappingURL=printWarningWithTrace.js.map